import { BASE_URL } from "./config";

// ✅ Get packages by country code (IN, AE, etc.)
export const getPackagesByCountry = async (countryCode) => {
  try {
    const res = await fetch(
      `${BASE_URL}/package/active/by-country/${countryCode}`
    );

    const data = await res.json();

    return data.data || []; // always return array
  } catch (err) {
    console.error("Error fetching packages:", err);
    return [];
  }
};

// ✅ Get packages for destination cards (NEW API)
export const getDestinationCards = async (countryCode) => {
  try {
    const res = await fetch(
      `${BASE_URL}/package/PackageOnDestination/${countryCode}`
    );

    if (!res.ok) throw new Error("Failed to fetch destination cards");

    const data = await res.json();

    return data.data || [];
  } catch (err) {
    console.error("Destination cards API error:", err);
    return [];
  }
};

// ✅ DETAIL PAGE API
export const getPackageById = async (id) => {
  try {
    const res = await fetch(`${BASE_URL}/package/active/${id}/detail`);

    const data = await res.json();

    return data.data || null;
  } catch (err) {
    console.error("Error fetching package detail:", err);
    return null;
  }
};

// ✅ HOME REELS API
export const getReels = async () => {
  try {
    const res = await fetch(`${BASE_URL}/reels/active`);

    const data = await res.json();

    if (data.success) {
      return data.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Reels API error:", error);
    return [];
  }
};